import { useContext, useEffect } from "react";
import RMMSContext from "../../context/RMMSContext";
import OLTileLayer from "ol/layer/Tile";

const TileLayer = ({ source, zIndex = 0 }) => {
	const { map } = useContext(RMMSContext);

	useEffect(() => {
		if (!map) return;

		let tileLayer = new OLTileLayer({
			source,
			zIndex,
		});

		map.addLayer(tileLayer);
		tileLayer.setZIndex(zIndex);

		return () => {
			if (map) {
				map.removeLayer(tileLayer);
			}
		};
		// eslint-disable-next-line
	}, [map, source]);

	return null;
};

export default TileLayer;